// source: starlord/messages/response/user_search_response.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var starlord_messages_models_ldap_user_details_pb = require('../../../starlord/messages/models/ldap_user_details_pb.js');
goog.object.extend(proto, starlord_messages_models_ldap_user_details_pb);
var common$protos_messages_models_error_details_pb = require('../../../common-protos/messages/models/error_details_pb.js');
goog.object.extend(proto, common$protos_messages_models_error_details_pb);
goog.exportSymbol('proto.UserSearchResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UserSearchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.UserSearchResponse.repeatedFields_, null);
};
goog.inherits(proto.UserSearchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.UserSearchResponse.displayName = 'proto.UserSearchResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.UserSearchResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UserSearchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.UserSearchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UserSearchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.UserSearchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalresults: jspb.Message.getFieldWithDefault(msg, 1, 0),
    userdetailsList: jspb.Message.toObjectList(msg.getUserdetailsList(),
    starlord_messages_models_ldap_user_details_pb.LdapUserDetails.toObject, includeInstance),
    errordetails: (f = msg.getErrordetails()) && common$protos_messages_models_error_details_pb.ErrorModel.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UserSearchResponse}
 */
proto.UserSearchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UserSearchResponse;
  return proto.UserSearchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UserSearchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UserSearchResponse}
 */
proto.UserSearchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalresults(value);
      break;
    case 2:
      var value = new starlord_messages_models_ldap_user_details_pb.LdapUserDetails;
      reader.readMessage(value,starlord_messages_models_ldap_user_details_pb.LdapUserDetails.deserializeBinaryFromReader);
      msg.addUserdetails(value);
      break;
    case 3:
      var value = new common$protos_messages_models_error_details_pb.ErrorModel;
      reader.readMessage(value,common$protos_messages_models_error_details_pb.ErrorModel.deserializeBinaryFromReader);
      msg.setErrordetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UserSearchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UserSearchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UserSearchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.UserSearchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalresults();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUserdetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      starlord_messages_models_ldap_user_details_pb.LdapUserDetails.serializeBinaryToWriter
    );
  }
  f = message.getErrordetails();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      common$protos_messages_models_error_details_pb.ErrorModel.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 totalResults = 1;
 * @return {number}
 */
proto.UserSearchResponse.prototype.getTotalresults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.UserSearchResponse} returns this
 */
proto.UserSearchResponse.prototype.setTotalresults = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated LdapUserDetails userDetails = 2;
 * @return {!Array<!proto.LdapUserDetails>}
 */
proto.UserSearchResponse.prototype.getUserdetailsList = function() {
  return /** @type{!Array<!proto.LdapUserDetails>} */ (
    jspb.Message.getRepeatedWrapperField(this, starlord_messages_models_ldap_user_details_pb.LdapUserDetails, 2));
};


/**
 * @param {!Array<!proto.LdapUserDetails>} value
 * @return {!proto.UserSearchResponse} returns this
*/
proto.UserSearchResponse.prototype.setUserdetailsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.LdapUserDetails=} opt_value
 * @param {number=} opt_index
 * @return {!proto.LdapUserDetails}
 */
proto.UserSearchResponse.prototype.addUserdetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.LdapUserDetails, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.UserSearchResponse} returns this
 */
proto.UserSearchResponse.prototype.clearUserdetailsList = function() {
  return this.setUserdetailsList([]);
};


/**
 * optional ErrorModel errorDetails = 3;
 * @return {?proto.ErrorModel}
 */
proto.UserSearchResponse.prototype.getErrordetails = function() {
  return /** @type{?proto.ErrorModel} */ (
    jspb.Message.getWrapperField(this, common$protos_messages_models_error_details_pb.ErrorModel, 3));
};


/**
 * @param {?proto.ErrorModel|undefined} value
 * @return {!proto.UserSearchResponse} returns this
*/
proto.UserSearchResponse.prototype.setErrordetails = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.UserSearchResponse} returns this
 */
proto.UserSearchResponse.prototype.clearErrordetails = function() {
  return this.setErrordetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.UserSearchResponse.prototype.hasErrordetails = function() {
  return jspb.Message.getField(this, 3) != null;
};


goog.object.extend(exports, proto);
